import { render, staticRenderFns } from "./VendorTransactions.vue?vue&type=template&id=2f21149c&scoped=true"
import script from "./VendorTransactions.vue?vue&type=script&lang=js"
export * from "./VendorTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21149c",
  null
  
)

export default component.exports